// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3rzbO","success":"Button_success__3jPMS","danger":"Button_danger__29nKO"};